<template>
    <v-list two-line style="padding-top:0px !important">
        <template v-for="(item, index) in items">

            <v-divider
                    v-if="item.divider"
                    :inset="item.inset"
                    :key="index"
            ></v-divider>

            <v-list-tile
                    v-else
                    :key="item.title + index"
                    avatar
            >

                <v-list-tile-content>
                    <v-list-tile-title style="text-align: center" v-html="item.title"></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </template>
    </v-list>
</template>

<script>
    export default {
        data() {
            return {
                items: [
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '4',
                    },
                    {divider: true, inset: false},
                    {
                        title: '200',
                    },
                    {divider: true, inset: false},
                    {
                        title: '5 GB',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle"></div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle-secondary"></div>',

                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle-secondary"></div>',

                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle-secondary"></div>',

                    },
                    {divider: true, inset: false},
                    {
                        title: '<div class="full-circle-secondary"></div>',

                    },
                ]
            }
        }
    }
</script>

<style scoped>

</style>